/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `sand` - sand
 * * `clay` - clay
 * @export
 */
export const LeveeMaterialEnum = {
  SAND: "sand",
  CLAY: "clay",
} as const;
export type LeveeMaterialEnum = (typeof LeveeMaterialEnum)[keyof typeof LeveeMaterialEnum];

export function instanceOfLeveeMaterialEnum(value: any): boolean {
  for (const key in LeveeMaterialEnum) {
    if (Object.prototype.hasOwnProperty.call(LeveeMaterialEnum, key)) {
      if (LeveeMaterialEnum[key as keyof typeof LeveeMaterialEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LeveeMaterialEnumFromJSON(json: any): LeveeMaterialEnum {
  return LeveeMaterialEnumFromJSONTyped(json, false);
}

export function LeveeMaterialEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LeveeMaterialEnum {
  return json as LeveeMaterialEnum;
}

export function LeveeMaterialEnumToJSON(value?: LeveeMaterialEnum | null): any {
  return value as any;
}

export function LeveeMaterialEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): LeveeMaterialEnum {
  return value as LeveeMaterialEnum;
}
